import React, { useContext } from 'react';
import { Modal } from 'cvlib';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslationEmptyOrNullKey } from 'utils/getTranslation';
import { hideSensitiveModal } from 'containers/Player/actions/sensitiveContent/sensitive.actions';
import { PlayerContext } from 'containers/Player/context/PlayerContext';
import LiveSensitiveContent from './components/LiveSensitiveContent';
import './index.scss';

const SensitiveModal = () => {
  const translations = useSelector(state => state.translations);
  const { Alerta_IconoAlerta } =
    useSelector(state => state.asset) || 'Alerta_IconoAlerta';

  const showSensitiveModal = useSelector(
    state => state?.Player?.sensitiveContent?.showModal,
  );
  const typeSensitiveModal = useSelector(state => state?.Player?.sensitiveContent?.typeModal)
  const dispatch = useDispatch();
  const { liveVideoTagRef } = useContext(PlayerContext);

  const handleAccept = (e) => {
    e?.stopPropagation();
    e?.preventDefault()
    dispatch(hideSensitiveModal());
    if (location.pathname.includes('watch'))
      return liveVideoTagRef.current.play();
  };

  const renderModalSensitiveContent = () => {
    if(typeSensitiveModal === 'live') return <LiveSensitiveContent />
    return (
      <div className={"verification-modal-container"} onClick={e => e.stopPropagation()}>
        <img src={Alerta_IconoAlerta} style={{width: "120px"}}/>
        <h2 className="verification-modal__title">
          {getTranslationEmptyOrNullKey(
            'Homes_AlertaFalloDeValidacion_CanalBloqueado_TextoInformativo',
            translations,
          )?.split('<br/>').map((text, index) => (
            <React.Fragment key={index}>
              {text}
              <br />
            </React.Fragment>
          ))}
        </h2>
        <button onClick={handleAccept} className="verification-modal__button">
          {getTranslationEmptyOrNullKey('Homes_Aceptar_TextoBotonPrimario', translations)}
        </button>
      </div>
    );
  };
  return (
    <Modal isOpen={showSensitiveModal} classNames={['verification-modal']}>
      {renderModalSensitiveContent()}
    </Modal>
  );
};

export default SensitiveModal;
